import { isTelegramWebAppActive, openInvoice } from '@/utils/telegramWebAppClient'
import { resolveApiErrorMessage } from '@/utils/apiResponse'

export const PAYMENT_METHOD_STARS = 'telegram_stars'
export const PAYMENT_METHOD_COBO = 'cobo'

let remoteStarsEnabled = null
let cachedStarsPerUsd = 77

function parseEnvFlag(value) {
  return String(value || '').trim().toLowerCase() === 'true'
}

/** 构建时开关：VUE_APP_TELEGRAM_STARS_ENABLED=true */
export function isTelegramStarsFeatureEnabled() {
  return parseEnvFlag(process.env.VUE_APP_TELEGRAM_STARS_ENABLED)
}

export function setRemoteTelegramStarsEnabled(enabled) {
  remoteStarsEnabled = enabled === true
}

export function isTelegramStarsEnabled() {
  if (!isTelegramStarsFeatureEnabled()) {
    return false
  }
  if (remoteStarsEnabled === false) {
    return false
  }
  return true
}

export function getStarsPerUsd() {
  return cachedStarsPerUsd || 77
}

export function estimateStarsFromUsd(amountUsd) {
  const price = Number(amountUsd)
  if (!Number.isFinite(price) || price <= 0) {
    return null
  }
  return Math.max(1, Math.ceil(price * getStarsPerUsd()))
}

export async function loadTelegramStarsConfig(api) {
  if (!isTelegramStarsFeatureEnabled() || !isTelegramWebAppActive()) {
    setRemoteTelegramStarsEnabled(false)
    return { enabled: false }
  }

  try {
    const res = await api.payment.getStarsPaymentConfig({ skipLoading: true })
    const enabled = res?.data?.data?.enabled === true
    const starsPerUsd = Number(res?.data?.data?.stars_per_usd)
    if (Number.isFinite(starsPerUsd) && starsPerUsd > 0) {
      cachedStarsPerUsd = starsPerUsd
    }
    setRemoteTelegramStarsEnabled(enabled)
    return {
      enabled,
      starsPerUsd: getStarsPerUsd(),
    }
  } catch (_) {
    setRemoteTelegramStarsEnabled(false)
    return { enabled: false }
  }
}

export async function createTelegramStarsInvoice(api, orderNo) {
  const payRes = await api.payment.createStarsPaymentOrder({ order_no: orderNo })
  const data = payRes?.data?.data
  if (payRes?.data?.status !== '0' || !data?.invoice_link) {
    return {
      ok: false,
      message: resolveApiErrorMessage(payRes?.data),
    }
  }
  return {
    ok: true,
    invoiceLink: data.invoice_link,
    starsAmount: data.stars_amount,
    amountUsd: data.amount_usd,
    expiredInMinutes: data.expired_in_minutes ?? 30,
    paymentMethod: PAYMENT_METHOD_STARS,
  }
}

export async function openTelegramStarsInvoice(invoiceLink) {
  return openInvoice(invoiceLink)
}

export function buildPendingStarsPayment({
  orderNo,
  invoiceLink,
  starsAmount,
  amountUsd,
  productName,
  expiredInMinutes = 30,
}) {
  return {
    orderNo,
    paymentLink: invoiceLink,
    invoiceLink,
    starsAmount,
    amountUsd,
    productName,
    paymentMethod: PAYMENT_METHOD_STARS,
    expiredInMinutes,
    createdAt: Date.now(),
  }
}
